import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Brand } from './Brand';
import { MAIN_ID, SkipLink } from './SkipLink';
import { ThemeToggle } from './ThemeToggle';
import { Spinner } from '@/components/ui';

/** Pages outside the authenticated area (shared reports, sign-in): no sidebar, phone friendly. */
export function PublicLayout() {
  return (
    <div className="min-h-screen bg-paper text-ink">
      <SkipLink />
      <header className="border-b border-line bg-surface">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-4 py-3 sm:px-6">
          <Brand />
          <ThemeToggle />
        </div>
      </header>
      <main
        id={MAIN_ID}
        tabIndex={-1}
        className="mx-auto max-w-4xl px-4 py-8 focus:outline-none sm:px-6"
      >
        <Suspense fallback={<Spinner />}>
          <Outlet />
        </Suspense>
      </main>
    </div>
  );
}
